import { getFilterConfig } from './getFilterConfig'

/**
 * Get display label for any filter item
 * @param {Object} item - The filter item object
 * @param {string} taxonomy - The taxonomy/attribute name
 * @returns {string|undefined} - The display label or undefined
 */
export const getDisplayLabel = (item, taxonomy) => {
  if (!item) {
    return undefined
  }

  const filterConfig = getFilterConfig(taxonomy)
  const displayMapping = filterConfig?.displayLabelMapping

  if (displayMapping && displayMapping[item.label]) {
    return displayMapping[item.label]
  }

  return item.label
}
